import { useNavigate } from '@tanstack/react-router'
import { EquipmentForm } from '@/components/EquipmentForm'
import { BLANK_VALUES } from '@/components/equipmentFormValues'
import { useCreateItem } from '@/lib/queries'

export function AddEquipment() {
  const navigate = useNavigate()
  const create = useCreateItem()

  return (
    <>
      <h1 className="page-title">Add equipment</h1>
      <p className="page-lede">
        Log a new item in under a minute. Brand and lamp fields autocomplete from what is already
        catalogued.
      </p>

      <EquipmentForm
        initial={BLANK_VALUES}
        submitLabel="Add to inventory"
        busy={create.isPending}
        error={create.error}
        onCancel={() => void navigate({ to: '/inventory' })}
        onSubmit={(input) => {
          create.mutate(input, {
            onSuccess: (item) =>
              void navigate({ to: '/inventory/$itemId', params: { itemId: String(item.id) } }),
          })
        }}
      />
    </>
  )
}
